import {Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, AfterViewInit, Input, Injectable} from '@angular/core';
import 'rxjs/add/operator/filter';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';

import { MenuItems } from '../../shared/menu-items/menu-items';
import { AuthenticationService } from '../../core/authentication.service';
import { Router } from '@angular/router';
import { Users } from "../../models/users";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjoutephemerideComponent } from 'app/ephemeride/ephemeride/ajoutephemeride/ajoutephemeride.component';
import { Ephemeride } from 'app/models/ephemeride';
import { EphemerideService } from "app/core/ephemeride.service";
import { ShowephemerideComponent } from './showephemeride/showephemeride.component';
import { ListephemerideComponent } from 'app/ephemeride/ephemeride/listephemeride/listephemeride.component';
import { UpdatePasswordComponent } from 'app/authentication/update-password/update-password.component';

export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
        state('no-block, void',
            style({
                overflow: 'hidden',
                height: '0px',
            })
        ),
        state('yes-block',
            style({
                height: AUTO_STYLE,
            })
        ),
        transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
        ])
    ])
  ]
})
@Injectable()
export class AdminLayoutComponent implements OnInit {
  connectedUser: Users;
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  windowWidth: number;
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;
  public ephemeride: Ephemeride[];
  @Input()
  ephemerides: Ephemeride;

  public page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: "id",
    orderDir: "DESC",
    etat: true
  };

 /* public ephemeride: Ephemeride[];*/

  constructor(public menuItems: MenuItems,
    public auth: AuthenticationService,
    public router: Router,
    private modalService: NgbModal,
    private ephemerideService: EphemerideService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
    this.auth.getConnectedUser().subscribe(user => {
      this.connectedUser = user;
    })
  }

  ngOnInit() {
    const params = {
      sortName: `${this.page.orderBy}`,
      sortType: `${this.page.orderDir}`,
      page: `${this.page.offset}`,
      size: `${this.page.limit}`
    };
    this.ephemerideService.find(params).subscribe(
      res => {
        this.ephemeride = res.body;
        this.page.count = +res.headers.get("total");
      },
      error => {
        console.error(error);
      }
    );
    /*this.loadEphemeride();*/
  }

 /* loadEphemeride() {
    this.ephemerideService.find().subscribe(ephemeride => {
      this.ephemeride = ephemeride;
    });
  }*/

  loadEphemeride() {

    const params = {
      sortName: `${this.page.orderBy}`,
      sortType: `${this.page.orderDir}`,
      page: `${this.page.offset}`,
      size: `${this.page.limit}`
    };
    this.ephemerideService.find(params).subscribe(
      res => {
        this.ephemeride = res.body;
        this.page.count = +res.headers.get("total");
      },
      error => {
        console.error(error);
      }
    );
  }

  onClickedOutside(e: Event) {
      if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
          this.toggleOn = true;
          this.verticalNavType = 'offcanvas';
      }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }

  setMenuAttributs(windowWidth) {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = 'tablet';
        this.verticalNavType = 'collapsed';
        this.verticalEffect = 'push';
      } else if (windowWidth < 768) {
        this.deviceType = 'mobile';
        this.verticalNavType = 'offcanvas';
        this.verticalEffect = 'overlay';
      } else {
        this.deviceType = 'desktop';
        this.verticalNavType = 'expanded';
        this.verticalEffect = 'shrink';
      }
  }

  searchFriendList(event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function(elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === 'out' ? 'in' : 'out';
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === 'off' ? 'on' : 'off';
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
        this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }

  onLogout() {
    this.auth.logout();
    this.router.navigate(['login']);
  }
  setPAssword() {
    const activeModal = this.modalService.open(UpdatePasswordComponent, {
      size: "sm"
    });
    activeModal.result.then(
      pa => {
        console.log(`modal closed with result: ${pa}`);
        this.loadEphemeride();
      },
      reason => {
        console.log(`modal Closed with: ${reason}`);
        this.loadEphemeride();
      }
    );
  }


  public ajoutEphemeride( ephemerides?:  Ephemeride) {
    const activeModal = this.modalService.open(ShowephemerideComponent, {
      size: "sm"
    });
    activeModal.componentInstance.ephemerides = ephemerides;
  if (ephemerides) {
      activeModal.componentInstance.ephemerides = ephemerides;
    }
    activeModal.result.then(
      pa => {
        console.log(`modal closed with result: ${ephemerides}`);
        this.loadEphemeride();
      },
      reason => {
        console.log(`modal Closed with: ${reason}`);
        this.loadEphemeride();
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/layouts/admin/admin-layout.component.ts